import { render, staticRenderFns } from "./CharityRun.vue?vue&type=template&id=a129e2e2&scoped=true"
import script from "./CharityRun.vue?vue&type=script&lang=js"
export * from "./CharityRun.vue?vue&type=script&lang=js"
import style0 from "./CharityRun.vue?vue&type=style&index=0&id=a129e2e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a129e2e2",
  null
  
)

export default component.exports